// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2eZoC","buttons":"Footer_buttons__2Sa9W"};